import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./auth/AuthProvider";

// The router sits OUTSIDE the auth provider so that App, which decides whether
// to render any route at all, is itself inside both. No path is reachable
// without passing the allowlist gate first.
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
